import { render, staticRenderFns } from "./LikeNotification.vue?vue&type=template&id=5a3f2360&"
import script from "./LikeNotification.vue?vue&type=script&lang=ts&"
export * from "./LikeNotification.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports